import authCheckApp from './authCheckApp'

/**
 * 改变导航栏标题
 * @since 1.0.0
 * @param {Object} - 包含了改变的信息
 * @param {string} title 标题
 * @example
 * 
 * modifyNavigationTitle({
 *     title: '新的标题'
 * })
 */
function modifyNavigationTitle(obj) {
    authCheckApp()
        .then(() => {
        // 发起请求
            window.WebViewJavascriptBridge.callHandler('webViewReset', {'title': obj.title}, (response) => {
                return response
            })
        })
}

export default modifyNavigationTitle